import { render, staticRenderFns } from "./InputCnpj.vue?vue&type=template&id=4d0ce5e9&scoped=true"
import script from "./InputCnpj.vue?vue&type=script&lang=js"
export * from "./InputCnpj.vue?vue&type=script&lang=js"
import style0 from "./InputCnpj.vue?vue&type=style&index=0&id=4d0ce5e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ce5e9",
  null
  
)

export default component.exports